/**
 * 租戶主題設定 API（tenant_sys_profile · porsche 2026-07-30）
 * role=3 對自己 tenant；SYSTEM_ADMIN 可帶 orgId 對別 tenant。
 * 圖片顯示走 public /api/system/branding-image/{file_object_id}。
 */
import axios from '../api/axios';

export interface TenantSysProfile {
  org_id: number;
  org_name: string;
  tenant_languages: string[];
  theme_color: string;      // blue | green | black | coffee
  layout_mode: string;      // vertical | horizontal
  logo_file_id: number | null;
  login_bg_file_id: number | null;
  favicon_file_id: number | null;
  system_name: Record<string, string>;
  tenant_copyright: Record<string, string>;
  timezone: string;
}

export interface TenantSysProfileUpdate {
  theme_color?: string;
  layout_mode?: string;
  system_name?: Record<string, string>;
  tenant_copyright?: Record<string, string>;
  timezone?: string;
}

// porsche 拍板：主題設定只能設自己所屬租戶（無 org_id 參數）。
const BASE = '/api/system/tenant-profile';

export const getTenantSysProfile = async (): Promise<TenantSysProfile> =>
  (await axios.get<TenantSysProfile>(`${BASE}/`)).data;

export const updateTenantSysProfile = async (
  data: TenantSysProfileUpdate,
): Promise<TenantSysProfile> =>
  (await axios.patch<TenantSysProfile>(`${BASE}/`, data)).data;

// ⚠️ FormData 上傳必覆蓋 Content-Type: multipart（axiosInstance 預設 json）
const _upload = async (path: string, file: File): Promise<TenantSysProfile> => {
  const fd = new FormData();
  fd.append('file', file);
  const resp = await axios.post<TenantSysProfile>(`${BASE}/${path}`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return resp.data;
};

export const uploadTenantLogo = (file: File) => _upload('logo', file);
export const uploadTenantLoginBg = (file: File) => _upload('login-bg', file);

/** public branding 圖片 URL（logo/favicon/login_bg 用 file_object_id） */
export const brandingImageUrl = (fileObjectId: number): string =>
  `/api/system/branding-image/${fileObjectId}`;
